module.exports = __webpack_public_path__ + "static/img/商会标.7331a94.gif";


//////////////////
// WEBPACK FOOTER
// ./static/image/商会标.gif
// module id = GVOY
// module chunks = 7